<template>
  <div class="fixed top-4 right-4 z-50">
    <button 
      @click="$emit('toggle-settings')"
      class="p-3 bg-gray-800 hover:bg-gray-700 rounded-full border border-gray-600 text-white settings-btn-float"
      title="Apri Impostazioni"
    >
      <i class="fas fa-cog text-xl"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'SettingsButton',
  emits: ['toggle-settings']
};
</script>